<template>
    <div class="side-bar">
        <perfect-scrollbar>
            <ul>
                <template v-for="(section, sectionIndex) of availableSections">
                    <li :key="`section_${sectionIndex}`" class="menu-title">
                        {{ section.name }}
                    </li>

                    <template v-for="(item, itemIndex) of section.items">
                        <li
                            v-if="hasUserPermissions(item.permission)"
                            :key="`${sectionIndex}_${itemIndex}`"
                        >
                            <router-link :to="item.url">
                                <i :class="item.icon" />
                                <span>{{ item.text }}</span>
                            </router-link>
                        </li>
                    </template>
                </template>
            </ul>
        </perfect-scrollbar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
    components: {
        PerfectScrollbar
    },

    data() {
        return {
            sections: [
                {
                    name: 'Academic course management',
                    permission: 'academic_courses_management',
                    items: [
                        {
                            text: 'Comments',
                            url: '/comments',
                            icon: 'fas fa-comments'
                        },
                        {
                            text: 'Courses',
                            url: '/academic-courses',
                            icon: 'fas fa-book-reader'
                        },
                        {
                            text: 'Files',
                            url: '/files',
                            icon: 'fas fa-file'
                        },
                        {
                            text: 'Reported content',
                            url: '/reported-content',
                            icon: 'fas fa-file-signature'
                        }
                    ]
                },
                {
                    name: 'Ads management',
                    permission: 'ads_management',
                    items: [
                        {
                            text: 'Ads',
                            url: '/ads',
                            icon: 'fas fa-ad'
                        },
                        {
                            text: 'Ad positions',
                            url: '/ad-positions',
                            icon: 'fas fa-ad'
                        }
                    ]
                },
                {
                    name: 'Article management',
                    permission: 'articles_management',
                    items: [
                        {
                            text: 'Articles',
                            url: '/articles',
                            icon: 'fas fa-newspaper'
                        },
                        {
                            text: 'Categories',
                            url: '/article-categories',
                            icon: 'fas fa-list'
                        },
                        {
                            text: 'Tags',
                            url: '/article-tags',
                            icon: 'fas fa-hashtag'
                        }
                    ]
                },
                {
                    name: 'Marathon management',
                    permission: 'marathons_management',
                    items: [
                        {
                            text: 'Marathons',
                            url: '/courses',
                            icon: 'fas fa-chalkboard'
                        },
                        {
                            text: 'Marathon Orders',
                            url: '/course-orders',
                            icon: 'fas fa-chalkboard'
                        },
                        {
                            text: 'Teachers',
                            url: '/teachers',
                            icon: 'fas fa-chalkboard-teacher'
                        }
                    ]
                },
                {
                    name: 'Shop management',
                    permission: 'shops_management',
                    items: [
                        {
                            text: 'Attributes',
                            url: '/attributes',
                            icon: 'fab fa-elementor'
                        },
                        {
                            text: 'Disclaimers',
                            url: '/disclaimers',
                            icon: 'fas fa-scroll'
                        },
                        {
                            text: 'Loan Shops',
                            url: '/loan-shops',
                            icon: 'fab fa-leanpub'
                        },
                        {
                            text: 'Loans',
                            url: '/loans',
                            icon: 'fas fa-swatchbook'
                        },
                        {
                            text: 'Orders',
                            url: '/orders',
                            icon: 'fas fa-file-invoice-dollar'
                        },
                        {
                            text: 'Shops',
                            url: '/shops',
                            icon: 'fas fa-cash-register'
                        },
                        {
                            text: 'Suppliers',
                            url: '/suppliers',
                            icon: 'fa fa-truck'
                        },
                        {
                            text: 'Tags',
                            url: '/product-tags',
                            icon: 'fas fa-hashtag'
                        }
                    ]
                },
                {
                    name: 'Students management',
                    permission: 'students_management',
                    items: [
                        {
                            text: 'Students',
                            url: '/students',
                            icon: 'fas fa-user-graduate'
                        },
                        {
                            text: 'Tags Categories',
                            url: '/student-tag-categories',
                            icon: 'fas fa-list'
                        },
                        {
                            text: 'Tags',
                            url: '/student-tags',
                            icon: 'fas fa-hashtag'
                        },
                        {
                            text: 'Student tags list',
                            url: '/student-tags-list',
                            icon: 'fas fa-hashtag'
                        }
                    ]
                },
                {
                    name: 'Stars products management',
                    permission: 'stars_products_management',
                    items: [
                        {
                            text: 'Star products',
                            url: '/star-products',
                            icon: 'fas fa-star'
                        },
                        {
                            text: 'Tiers',
                            url: '/tiers',
                            icon: 'fas fa-list-ol'
                        }
                    ]
                },
                {
                    name: 'Footer management',
                    permission: 'contents',
                    items: [
                        {
                            text: 'Footer columns',
                            url: '/footer-columns',
                            icon: 'fas fa-columns'
                        },
                        {
                            text: 'Footer Links',
                            url: '/footer-links',
                            icon: 'fas fa-link'
                        }
                    ]
                },
                {
                    name: 'Other',
                    items: [
                        {
                            text: 'Boards',
                            url: '/boards',
                            icon: 'fas fa-copy',
                            permission: 'boards'
                        },
                        {
                            text: 'Campuses',
                            url: '/campuses',
                            icon: 'fas fa-store'
                        },
                        {
                            text: 'Contents',
                            url: '/contents',
                            icon: 'fas fa-book-open',
                            permission: 'contents'
                        },
                        {
                            text: 'Events',
                            url: '/events',
                            icon: 'fas fa-calendar-alt'
                        },
                        {
                            text: 'Forms',
                            url: '/forms',
                            icon: 'fab fa-wpforms'
                        },
                        {
                            text: 'Homepage',
                            url: '/homepage-components',
                            icon: 'fas fa-home',
                            permission: 'contents'
                        },
                        {
                            text: 'Media',
                            url: '/media',
                            icon: 'fas fa-images'
                        },
                        {
                            text: 'Notifications',
                            url: '/notifications',
                            icon: 'fas fa-bell'
                        },
                        {
                            text: 'Posts',
                            url: '/posts',
                            icon: 'fas fa-align-left'
                        },
                        {
                            text: 'Requests',
                            url: '/requests',
                            icon: 'far fa-copy'
                        },
                        {
                            text: 'Settings',
                            url: '/settings',
                            icon: 'fas fa-cog',
                            permission: 'settings'
                        },
                        {
                            text: 'Simple Pages',
                            url: '/pages',
                            icon: 'far fa-file',
                            permission: 'contents'
                        },
                        {
                            text: 'Terms of use',
                            url: '/terms-of-use',
                            icon: 'fa fa-clipboard',
                            permission: 'contents'
                        },
                        {
                            text: 'Transparency',
                            url: '/transparency',
                            icon: 'fas fa-file-import',
                            permission: 'contents'
                        },
                        {
                            text: 'Users',
                            url: '/users',
                            icon: 'fas fa-users',
                            permission: 'users'
                        },
                        {
                            text: 'Hugs',
                            url: '/hugs',
                            icon: 'fas fa-university',
                            permission: 'users'
                        }
                    ]
                }
            ]
        };
    },

    computed: {
        ...mapGetters({
            user: 'auth/loggedUser'
        }),

        permissions() {
            return this.user?.acl?.permissions;
        },

        availableSections() {
            return this.sections.filter(
                section =>
                    !section.permission ||
                    (this.permissions &&
                        this.permissions[section.permission]) ||
                    this.permissions?.all
            );
        }
    },

    methods: {
        hasUserPermissions(permission) {
            if (!permission) {
                return true;
            }

            return (
                (this.permissions && this.permissions[permission]) ||
                this.permissions?.all
            );
        }
    }
};
</script>
